<template>
    <span>
        <span class="text-primary" v-if="tipo != 'B'">
            <i
                class="fa fa-history fa-lg icon-button"
                title="Exibir Histórico"
                @click.stop="obterHistorico()"
            ></i>
        </span>
        <b-button
            variant="primary"
            @click.stop="obterHistorico()"
            v-if="tipo == 'B'"
        >
            <span> <i class="fa fa-calendar"></i> Histórico</span>
        </b-button>
        <b-modal v-model="mostrarModal" :cancel-disabled="true" scrollable>
            <div slot="modal-title">
                {{ titulo }}
            </div>
            <b-row
                v-for="item in historico"
                :key="`${item.acao}-${item.dataCadastro}`"
            >
                <b-col sm="12">
                    <historico-detalhe :historico="item"></historico-detalhe>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="primary" @click.stop="fecharModal()"
                    >Ok</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import HistoricoDetalhe from './HistoricoDetalhe'

export default {
    components: {
        HistoricoDetalhe
    },

    props: {
        servicos: {
            type: Object,
            default: () => ({})
        },

        titulo: {
            type: String
        },

        id: {
            type: String
        },

        tipo: {
            type: String,
            default: () => 'B'
        }
    },

    data() {
        return {
            mostrarModal: false,
            historico: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterHistorico() {
            this.$store.dispatch('addRequest')
            this.servicos.obterHistorico(this.id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.historico = response.data
                        this.mostrarModal = true
                    } else {
                        this.$toast.error(
                            'Erro ao obter histórico',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
